import React, { useEffect, useState } from "react";
import TextInput from "components/FormElements/TextInput";

function SecuretextMetaProperty(props) {
    const [type, setType] = useState("text");
    const { value } = props;

    useEffect(() => {
        setType(value ? "text" : "password");
    }, [value]);

    return <TextInput name={props.name} type={type} />;
}

export default SecuretextMetaProperty;

export const Property = SecuretextMetaProperty;

export const Label = "Encrypted Text";
